import React, { useEffect } from "react";
import ProductsMainSection from "../ProductsMainSection/ProductsMainSection";

export function ProductsLayout() {
  return <ProductsMainSection />;
}
